import { useEffect, useState } from "react"

// Position a portaled popover below its anchor and
// right-align to the anchor's right edge. `width` lets each
// caller declare its actual popover width so the right-align
// math is correct (the date popover is 280px, the owner
// popover 224px — sharing one width broke the latter).
//
// Recomputes on resize + scroll (capture phase, so it tracks
// inner scroll containers too) and clamps HORIZONTALLY inside
// the viewport with an 8px gutter. Vertical position stays
// anchored below the trigger (no top clamp) — same behavior
// as the deal-card original this was extracted from.
export function useAnchoredPosition(
  anchor: HTMLElement,
  width: number,
) {
  const [position, setPosition] = useState({ top: 0, left: 0 })

  useEffect(() => {
    function compute() {
      const rect = anchor.getBoundingClientRect()
      const top = rect.bottom + 4
      const desiredLeft = rect.right - width
      const left = Math.max(
        8,
        Math.min(window.innerWidth - width - 8, desiredLeft),
      )
      setPosition({ top, left })
    }
    compute()
    window.addEventListener("resize", compute)
    window.addEventListener("scroll", compute, true)
    return () => {
      window.removeEventListener("resize", compute)
      window.removeEventListener("scroll", compute, true)
    }
  }, [anchor, width])

  return position
}
